import React, { useState, forwardRef, useEffect } from "react";
import { Row, Col } from "antd";
import SwitchItem from "../../../components/forms/SwitchItem";
import { InputItem } from "../../../components/forms/FormItems";
import AutoCompleteItem from "../../../components/forms/AutoCompleteItem";
import LocationFormItem from "../../../components/forms/LocationFormItem";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";

const ContactInformation = forwardRef((props, ref) => {
  const { smallSpace } = props;
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const changedValues = useSelector(
    (state) => state.patientDetails.changedItems.values
  );
  const [city, setCity] = useState(null);
  const [street, setStreet] = useState(null);
  const [houseNumber, setHouseNumber] = useState(null);
  useEffect(() => {
    if (activePatient && activePatient["address"]) {
      setCity(activePatient["address"].city);
      setStreet(activePatient["address"].street);
      setHouseNumber(activePatient["address"].house_number);
    }
  }, [activePatient]);

  const onCityChanged = (value) => {
    setCity(value);
  };

  const onStreetChanged = (e) => {
    setStreet(e.target.value);
  };

  const onHouseNumberChanged = (e) => {
    setHouseNumber(e.target.value);
  };
  const hasTemporaryAddress =
    changedValues["has_temporary_address"] === true ||
    (changedValues["has_temporary_address"] === undefined &&
      activePatient?.has_temporary_address === true);

  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface smallSpace={smallSpace}>
        <FormHeader
          title={<FormattedMessage id="app.patients.contactInformation" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <PhoneNumberItem
                  name="contact_info.phone_number"
                  category="patient"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <PhoneNumberItem
                  name="contact_info.phone_number2"
                  category="patient"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <PhoneNumberItem
                  name="contact_info.mobile_number"
                  category="patient"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <PhoneNumberItem
                  name="contact_info.fax_number"
                  category="patient"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="contact_info.email"
                  email={true}
                  category="patient"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="contact_info.agree_to_receive_sms"
                  category="patient"
                  trueFalse={true}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="contact_info.agree_to_receive_email"
                  category="patient"
                  trueFalse={true}
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>

      <Surface smallSpace={smallSpace}>
        <FormHeader title={<FormattedMessage id="app.patients.address" />} />
        <Row>
          <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AutoCompleteItem
                  name="address.city"
                  category="patient"
                  city={true}
                  onChange={onCityChanged}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem
                  name="address.street"
                  category="patient"
                  onChange={onStreetChanged}
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="address.house_number"
                  category="patient"
                  onChange={onHouseNumberChanged}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <InputItem name="address.apartment_number" category="patient" />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="address.postal_code"
                  category="patient"
                  postalCode={true}
                />
              </div>
              <Spacer horizontal={true} />

              <div style={{ flex: 1 }}>
                <InputItem
                  name="contact_info.mailbox_number"
                  category="patient"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="address_instructions.floor"
                  category="patient"
                  number={true}
                />
              </div>
              <Spacer horizontal={true} />

              <div style={{ flex: 1 }}>
                <InputItem
                  name="address_instructions.entrance"
                  category="patient"
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <InputItem
                  name="address_instructions.required_code"
                  category="patient"
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <SettingsDataSelect
                  name="service_area_id"
                  category="patient"
                  settingsdataName={"system_tables/service_areas"}
                  filterItems={(data) => {
                    return data.filter((i) => {
                      const itemIds = i.branches.map((j) => j.id);
                      return itemIds.includes(activePatient.branch);
                    });
                  }}
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            xxl={{ span: 12, offset: 2 }}
          >
            <LocationFormItem
              name="geo"
              category="patient"
              city={city}
              street={street}
              houseNumber={houseNumber}
            />
          </Col>
        </Row>
      </Surface>

      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.patients.temporary_address" />}
        />

        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <SwitchItem name="has_temporary_address" category="patient" />
              </div>
              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
        {hasTemporaryAddress && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <AutoCompleteItem
                    name="temporary_address.city"
                    category="patient"
                    city={true}
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="temporary_address.street"
                    category="patient"
                  />
                </div>
              </ResponsiveItemsWrapper>

              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="temporary_address.house_number"
                    category="patient"
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="temporary_address.apartment_number"
                    category="patient"
                  />
                </div>
              </ResponsiveItemsWrapper>

              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="temporary_address.postal_code"
                    category="patient"
                    postalCode={true}
                  />
                </div>
                <Spacer horizontal={true} />

                <div style={{ flex: 1 }}>
                  <SwitchItem
                    name="use_temporary_address_for_service"
                    category="patient"
                  />
                </div>
              </ResponsiveItemsWrapper>

              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="temporary_address_details"
                    category="patient"
                  />
                </div>
              </ResponsiveItemsWrapper>
            </Col>
          </Row>
        )}
      </Surface>
    </div>
  );
});

export default ContactInformation;
